
import React, { useMemo, useCallback, useState } from 'react';
import {
  Row, 
  Col,
  InputGroup,
  Input
} from 'reactstrap';
import { fetchUserFormList } from 'api/actions/forms'
import { fetcher } from 'api/client'
import { useQuery } from 'react-query'
import { useTable } from 'react-table'
import { useTranslation } from 'react-i18next'

import ReactTable from 'components/Shared/ReactTable'
import { MainHeader } from 'components/Shared/MainHeader'
import ItemDetail from 'components/Shared/ItemDetail';
import { Participant, Questions, Attachments } from './content';

const tabs = [
  {
      name: 'participant',
      icon: 'user',
      Component: Participant,
      tooltip: ({ t }) => t('participant'),
      shouldShow: ({ contract, profileAbility }) => {
          return true;
          // return profileAbility.can('read', 'Template', 'milestones');
      }
  },
  {
      name: 'questions',
      icon: 'question-circle',
      Component: Questions,
      tooltip: ({ t }) => t('questions'),
      shouldShow: ({ contract, profileAbility }) => {
          return true;
          // return profileAbility.can('read', 'Template', 'milestones');
      }
  },
  {
      name: 'attachments',
      icon: 'file',
      Component: Attachments,
      tooltip: ({ t }) => t('attachments'),
      shouldShow: ({ contract, profileAbility }) => {
          return true;
          // return profileAbility.can('read', 'Template', 'milestones');
      }
  },
  // { 
  //     name: 'collaborators', 
  //     icon: 'users', 
  //     Component: Collaborators ,
  //     tooltip: ({ t }) => t('contracts.collaborators.title'),
  //     shouldShow: ({ contract, profileAbility }) => {
  //         return true;
  //         // return profileAbility.can('read', 'Contract', 'collaboration');
  //     }
  // },
]

export function UserFormDetail({ isOpen, currentUserForm, onClose, defaultTab }) {

  return (
    <ItemDetail 
      isOpen={isOpen}
      title={`${currentUserForm?.template?.name || ''} - ${currentUserForm?.participant?.email || ''}`}
      onClose={onClose}
      tabs={tabs}
      defaultTab={defaultTab}
      userForm={currentUserForm}
    />
  )
}